import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { AppSurface } from '~/components/surface/app-surface';
import { RouteAppWrapper } from '~/components/route-app-wrapper';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

const ClaimsSingle = lazy(() => import('~/apps/self-serve/journey/ClaimsSingle'));

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SELFSERVE);

  useOnLoad(() => {
    const title = t('CLAIMS_PAGE_TITLE', { defaultValue: 'Claims' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SELFSERVE });
    navigationDispatch({ type: 'INITIALISE_NAVIGATION', payload: { title: title, home: RoutingConstants.Claims } });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Claims
      }
    });
  });

  return (
    <Tagged tag="screen-claims-item">
      <RouteAppWrapper isXs={isXs}>
        <AppSurface>
          <Suspense>
            <ClaimsSingle />
          </Suspense>
        </AppSurface>
      </RouteAppWrapper>
    </Tagged>
  );
}

Component.displayName = 'Claims';
